// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { reactionsConfig } from '@/lib/analytics/kpis/pinterest/reactions';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerReactionsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...reactionsConfig,
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
